/****************************************************
 * Module Name:  pdfModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import logo from '../../images/pansuriya.jpg'
import Constants from "../../utility/constants";

const PDFModal = ({ show, onHide, pdfByteString, pdfName }) => {
    const [pdfUrl, setPdfUrl] = useState(null);
    const defaultLayoutPluginInstance = defaultLayoutPlugin();

    useEffect(() => {
        if (pdfByteString) {
            const byteCharacters = atob(pdfByteString);
            const byteArray = new Uint8Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteArray[i] = byteCharacters.charCodeAt(i);
            }
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const blobUrl = URL.createObjectURL(blob);
            setPdfUrl(blobUrl);

            return () => URL.revokeObjectURL(blobUrl);
        }
    }, [pdfByteString]);

    const handleDownload = () => {
        const a = document.createElement('a');
        a.href = pdfUrl;
        a.download = pdfName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="xl"
            centered
            style={{ width: '100%', margin: 'auto' }}
            enforceFocus={false}
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    <img
                        src={logo}
                        height="40pt"
                        width="40pt"
                        alt={Constants.COMPANY_SITE}
                    />
                    &nbsp;&nbsp; View Pdf
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {pdfUrl && (
                    <Worker workerUrl={`https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js`}>
                        <div style={{ height: '70vh', overflow: 'auto' }}>
                            <Viewer
                                fileUrl={pdfUrl}
                                plugins={[defaultLayoutPluginInstance]}
                                defaultScale={1.25}
                                theme={{
                                    primaryColor: '#ffffff',
                                    secondaryColor: '#ffffff',
                                    textColor: '#ffffff',
                                    backgroundColor: '#1c1c1c',
                                }}
                            />

                        </div>
                    </Worker>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Close
                </Button>
                <Button variant="primary" onClick={handleDownload}>
                    Download
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default PDFModal;
